import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './locales/zh_CN.json'
import enHK from './locales/en_HK.json'
import StorageUtils from '@/core/storageUtils'
import Utils from '@/core/utils'
import ElementUI from 'element-ui'
import localeZH from 'element-ui/lib/locale/lang/zh-CN'
import localeEN from 'element-ui/lib/locale/lang/en'

Vue.use(VueI18n)

const valiLanguages = ['zh_CN', 'en_HK']
// Element UI 语言包映射
const elementLocaleMap = {
  zh_CN: localeZH,
  en_HK: localeEN
}

// 从URL参数或本地存储获取语言设置，默认为中文
// 优先级：URL参数 > localStorage > 默认值(zh_CN)
const getDefaultLocale = () => {
  // 优先从URL参数获取lang
  const urlLangParam = Utils.getUrlQuery('language')
  if (urlLangParam && urlLangParam.trim()) {
    try {
      // 解码URL参数值（防止URL编码）
      const urlLang = decodeURIComponent(urlLangParam).trim()
      // 验证是否为支持的语言
      if (valiLanguages.includes(urlLang)) {
        // 如果URL中有有效的lang参数，保存到localStorage
        StorageUtils.localStorage.set('language', urlLang)
        return urlLang
      }
    } catch (e) {
      // 如果解码失败，忽略URL参数，继续使用localStorage或默认值
      console.warn('Failed to decode lang parameter:', e)
    }
  }
  // 如果没有URL参数或参数无效，从localStorage获取
  return StorageUtils.localStorage.get('language') || 'zh_CN'
}

// 初始化 Element UI 语言
const initElementLocale = (locale) => {
  const elementLocale = elementLocaleMap[locale] || elementLocaleMap.zh_CN
  ElementUI.locale(elementLocale)
}

// 获取默认语言
const defaultLocale = getDefaultLocale()

// 初始化 Element UI 语言
initElementLocale(defaultLocale)

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: defaultLocale, // 设置默认语言
  fallbackLocale: 'zh_CN', // 设置回退语言
  messages: {
    zh_CN: zhCN,
    en_HK: enHK
  },
  silentTranslationWarn: true, // 静默翻译警告
  silentFallbackWarn: true // 静默回退警告
})

// 切换语言的方法
export const setLocale = (locale) => {
  i18n.locale = locale
  StorageUtils.localStorage.set('language', locale)
  // 同时切换 Element UI 的语言
  initElementLocale(locale)
}

// 获取当前语言
export const getLocale = () => {
  return i18n.locale
}

export default i18n
